import FormDialog from "../../helpers/FormDialog";

export const RelativeDetailsEdit = ({
  onSuccess,
  setOpen,
  open,
  resourceId,
  setValue0,
  value,
}) => {
  return (
    <FormDialog
      maxWidth={"md"}
      open={open > 0}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/family-relation/create" : `/api/resource/family-relation/update/${resourceId}`}
      title={open === 1 ? "Add Relative" : "Edit Relative Information"}
      fields={[
        {
          name: "relations",
          label: "Family Relations",
          type: "array",
          value: value["relations"],
          setValue: (val) => setValue0("relations", val),
          itemLabel: (index, values) => {
            const record = values[index];
            return `Relative #${index + 1} - ${record?.relationType || 'New'}`;
          },

          fields: [
            {
              name: "relationType",
              label: "Relationship Type",
              type: "select",
              values: [
                { label: "Brother", value: "brother" },
                { label: "Sister", value: "sister" },
                { label: "Paternal Uncles", value: "paternal_uncle" },
                { label: "Maternal Uncles", value: "maternal_uncle" },
                { label: "Paternal Aunties", value: "paternal_aunt" },
                { label: "Maternal Aunties", value: "maternal_aunt" },
                // { label: "Spouse", value: "spouse" },
              ],
              required: true,
              value: value["relationType"],
              setValue: (val, index) => {
                const relations = Array.isArray(value["relations"]) ? value["relations"] : [];
                const updatedRecords = [...relations];
                updatedRecords[index] = { ...updatedRecords[index], relationType: val };
                setValue0("relations", updatedRecords);
              },
            },
            {
              name: "relationName",
              label: "Relative's Name",
              type: "text",
              required: true,
              value: value["relationName"],
              setValue: (val, index) => {
                const relations = Array.isArray(value["relations"]) ? value["relations"] : [];
                const updatedRecords = [...relations];
                updatedRecords[index] = { ...updatedRecords[index], relationName: val };
                setValue0("relations", updatedRecords);
              },
            },
            {
              name: "placeOfWork",
              label: "Place of Work",
              type: "text",
              required: true,
              value: value["placeOfWork"],
              setValue: (val, index) => {
                const relations = Array.isArray(value["relations"]) ? value["relations"] : [];
                const updatedRecords = [...relations];
                updatedRecords[index] = { ...updatedRecords[index], placeOfWork: val };
                setValue0("relations", updatedRecords);
              },
            },
            {
              name: "country",
              label: "Country",
              type: "text",
              required: true,
              value: value["country"],
              setValue: (val, index) => {
                const relations = Array.isArray(value["relations"]) ? value["relations"] : [];
                const updatedRecords = [...relations];
                updatedRecords[index] = { ...updatedRecords[index], country: val };
                setValue0("relations", updatedRecords);
              },
            },
            {
              name: "mobileNumber",
              label: "Mobile Number",
              type: "tel",
              required: true,
              value: value["mobileNumber"],
              setValue: (val, index) => {
                const relations = Array.isArray(value["relations"]) ? value["relations"] : [];
                const updatedRecords = [...relations];
                updatedRecords[index] = { ...updatedRecords[index], mobileNumber: val };
                setValue0("relations", updatedRecords);
              },
            },
          ],
        },
      ]}
    />
  );
};

